// extracted by mini-css-extract-plugin
module.exports = {"root":"WImage_root__2GO3i","root--objectFit-cover":"WImage_root--objectFit-cover__lxg_c","root--objectFit-contain":"WImage_root--objectFit-contain__e94_9"};